/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import {createToaster, Portal, Toaster as ChakraToaster} from '@chakra-ui/react3'
import Toast from '../../leap/components/toast'
import {Chakra3Theme} from '../../leap/theme'

export const topToaster = createToaster({
    placement: 'top-end',
    pauseOnPageIdle: false,
    offsets: {
        top: 'calc(var(--header-clearance-block-size, 0px) + var(--subnavigation-height, 0px) + 1rem)',
        right: '1rem',
        bottom: '1rem',
        left: '1rem'
    }
})

export const bottomToaster = createToaster({
    placement: 'bottom-end',
    pauseOnPageIdle: false,
    offsets: {
        top: '1rem',
        right: '1rem',
        bottom: '1rem',
        left: '1rem'
    }
})

export const toaster = bottomToaster

export const Toaster = () => {
    return (
        <Portal>
            {/* toasts have no dark design */}
            <Chakra3Theme theme="light">
                <ChakraToaster toaster={topToaster}>
                    {(toast) => (
                        <Toast
                            key={toast.id}
                            id={toast.id}
                            title={toast.title}
                            description={toast.description}
                            type={toast.type}
                            icon={toast.icon}
                            action={toast.action}
                            isClosable={toast.isClosable !== false}
                            onClose={() => topToaster.dismiss(toast.id)}
                        />
                    )}
                </ChakraToaster>
                <ChakraToaster toaster={bottomToaster}>
                    {(toast) => (
                        <Toast
                            key={toast.id}
                            id={toast.id}
                            title={toast.title}
                            description={toast.description}
                            type={toast.type}
                            icon={toast.icon}
                            action={toast.action}
                            isClosable={toast.isClosable !== false}
                            onClose={() => bottomToaster.dismiss(toast.id)}
                        />
                    )}
                </ChakraToaster>
            </Chakra3Theme>
        </Portal>
    )
}

export default Toaster
